import { useFormatQuantity } from '@webapp/hooks'

export interface IQuantityProps {
  quantity: number | string
  mdp?: boolean
  decimalPlaces?: number
}

export const Quantity = ({
  mdp = false,
  quantity,
  decimalPlaces,
}: IQuantityProps) => {
  const formatQuantity = useFormatQuantity({
    mdp,
    decimalPlaces,
  })

  return <>{formatQuantity(quantity)}</>
}

Quantity.displayName = 'Quantity'
